export default "__VITE_ASSET__34f96b08__"